import { animate, motion, useMotionValue } from 'motion/react';
import React from 'react';
import ComingSoonWrap from '../../meta/ComingSoon';
import { Link } from 'react-router';

const FooterListItem: React.FC<any> = ({ children }) => {
    const barWidth = useMotionValue('0%');
    const textScale = useMotionValue(1);

    return (
        <motion.li
            style={{ scale: textScale }}
            onHoverStart={() => {
                animate(barWidth, '100%');
                animate(textScale, 1.05);
            }}
            onHoverEnd={() => {
                animate(barWidth, '0%');
                animate(textScale, 1);
            }}
            className='w-full hover:cursor-pointer relative'>
            <motion.span style={{ scale: textScale }}>{children}</motion.span>
            <motion.div style={{ width: barWidth }} className='h-1 mt-1 right-0 bottom-0 bg-neutral-800 absolute' />
        </motion.li>
    )
}

const PipsFooter: React.FC = () => {
    return (
        <div className='grid grid-cols-2 sm:flex gap-y-2 gap-x-6 p-6 bg-neutral-100 text-gray-900 shadow-inner'>
            <div className='flex flex-col'>
                <h2 className='font-semibold'>Need help?</h2>
                <ul className='flex flex-col w-full'>
                    <ComingSoonWrap>
                        <FooterListItem>FAQ</FooterListItem>
                    </ComingSoonWrap>
                    <ComingSoonWrap>
                        <FooterListItem>Customer Service</FooterListItem>
                    </ComingSoonWrap>
                    <Link to='/pips/contact'>
                        <FooterListItem>Contact</FooterListItem>
                    </Link>
                </ul>
            </div>

            <div className='flex flex-col'>
                <h2 className='font-semibold'>Legal</h2>
                <ul className='flex flex-col w-full'>
                    <ComingSoonWrap>
                        <FooterListItem>Privacy Notice</FooterListItem>
                    </ComingSoonWrap>
                    <ComingSoonWrap>
                        <FooterListItem>Cancellations</FooterListItem>
                    </ComingSoonWrap>
                </ul>
            </div>

            <div className='flex flex-col'>
                <h2 className='font-semibold'>Retail</h2>
                <ul className='flex flex-col w-full'>
                    <ComingSoonWrap>
                        <FooterListItem>Our Partners</FooterListItem>
                    </ComingSoonWrap>
                    <ComingSoonWrap>
                        <FooterListItem>Store Finder</FooterListItem>
                    </ComingSoonWrap>
                </ul>
            </div>

        </div>
    )
}

export default PipsFooter;